import React from "react";
import { DEBT_REPORT_KEYS } from "../../../common/DebtLoadCalculation/constants/constants";

export const DebtReportDataView = ({ data }) => {
  if (!data) return null;

  const values = {
    [DEBT_REPORT_KEYS.TOTAL_DEAL_AMOUNT]: `${data.totalDealAmount} BYN`,
    [DEBT_REPORT_KEYS.TOTAL_DEBT_LOAD_DEAL_AMOUNT]: `${data.totalDebtLoadDealAmount} BYN`,
    [DEBT_REPORT_KEYS.TOTAL_COUNT_DEALS]: `${data.totalCountDeals} шт.`,
    [DEBT_REPORT_KEYS.TOTAL_COUNT_DEBT_OVERLOADED_DEALS]: `${data.totalCountDebtOverloadedDeals} шт.`,
  };

  return (
    <div className="form-element flex-gap fullwidth">
      {Object.entries(values).map(([label, value]) => (
        <div className="d-flex flex-direction-row flex-space-between fullwidth" key={label}>
          <label>{label}:</label>
          <span className="font-bold">{value}</span>
        </div>
      ))}
    </div>
  );
};